import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import isMobile from "is-mobile";
import { useState, useRef, useCallback, useEffect } from "react";
import { Box } from "../Box/Box.mjs";
import { Toast } from "./Toast.mjs";
import { useFlipList } from "./useFlipList.mjs";
import { toaster } from "./Toaster.css.mjs";
const StaticToaster = (props) => /* @__PURE__ */ jsx(Box, { width: "full", className: toaster, ...props });
const Toaster = ({ toasts, removeToast }) => {
  const [expanded, setExpanded] = useState(false);
  const { itemRef, remove } = useFlipList(expanded);
  const isMobileDevice = useRef(isMobile()).current;
  const expandHandler = () => setExpanded(true);
  const collapseHandler = () => setExpanded(false);
  const onClose = useCallback(
    (dedupeKey, toastKey) => {
      remove(toastKey, () => {
        removeToast(dedupeKey);
      });
    },
    [remove, removeToast]
  );
  useEffect(() => {
    if (toasts.length <= 1) {
      setExpanded(false);
    }
  }, [toasts.length]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isMobileDevice && expanded && toasts.length > 1 && /* @__PURE__ */ jsx(
      Box,
      {
        position: "fixed",
        inset: 0,
        zIndex: "notification",
        onClick: () => setExpanded(false)
      }
    ),
    /* @__PURE__ */ jsx(
      StaticToaster,
      {
        position: "fixed",
        zIndex: "notification",
        onMouseEnter: !isMobileDevice ? expandHandler : void 0,
        onMouseLeave: !isMobileDevice ? collapseHandler : void 0,
        onFocus: expandHandler,
        onBlur: collapseHandler,
        onClick: () => setExpanded(!expanded),
        pointerEvents: toasts.length === 0 ? "none" : void 0,
        children: toasts.map(({ toastKey, ...rest }) => /* @__PURE__ */ jsx(
          Toast,
          {
            ref: itemRef(toastKey),
            toastKey,
            onClose,
            expanded,
            ...rest
          },
          toastKey
        ))
      }
    )
  ] });
};
export {
  Toaster
};
